import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import * as Sentry from '@sentry/react'

import { APP_NAME } from './lib/constants'
import { m } from './lib/paraglide/messages'
import { initPostHog } from './lib/posthog'
import { initSentry } from './lib/sentry'
import { registerPwaUpdater } from './lib/pwa-updater'
import { router } from './router'
import './styles.css'

document.title = APP_NAME
initSentry()
initPostHog()
registerPwaUpdater()

window.__APP_VERSION__ = {
    version: __APP_VERSION__,
    channel: __APP_CHANNEL__,
    commit: __APP_COMMIT__,
    builtAt: __APP_BUILT_AT__,
}

const rootElement = document.getElementById('root')!

ReactDOM.createRoot(rootElement).render(
    <StrictMode>
        <Sentry.ErrorBoundary
            fallback={
                <div className="flex h-screen items-center justify-center">
                    <p>{m.common_error_reload()}</p>
                </div>
            }
        >
            <RouterProvider router={router} />
        </Sentry.ErrorBoundary>
    </StrictMode>,
)
